import React from 'react';
import CreateManualOrder from '../components/ManualOrders/CreateManualOrder';
import AdminRouteGate from '../components/feedback/AdminRouteGate';

/**
 * Manual-order capture is admin-only.
 *
 * Every endpoint behind this wizard is IsAdmin-gated, so a vendor who reached it
 * would get the whole form and a 403 on submit. Bounce them to Orders rather
 * than render a screen that cannot work — the same guard TerminalLabels uses.
 */
function TerminalManualOrder() {
  return (
    <AdminRouteGate>
      <CreateManualOrder />
    </AdminRouteGate>
  );
}

export default TerminalManualOrder;
